import { useMemo } from 'react';
import { format, parse, startOfWeek, getDay } from 'date-fns';
import { enUS } from 'date-fns/locale/en-US';
import { Calendar as BigCalendar, dateFnsLocalizer } from 'react-big-calendar';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import { useSearchParams } from 'react-router-dom';
import useCalendar from '@/hooks/useCalendar';
import { ICalendarEvent } from '@/types';

const locales = {
  'en-US': enUS,
};

const localizer = dateFnsLocalizer({
  format,
  parse,
  startOfWeek,
  getDay,
  locales,
});

const Calendar = () => {
  const [searchParams] = useSearchParams();
  const date = searchParams.get('date');
  const calendar = useCalendar();
  const events = useMemo(() => calendar.data || [], [calendar.data]);

  const parseEvents =
    events?.events?.map((event: ICalendarEvent) => ({
      id: event.id,
      title: event.details,
      color: event.color,
      start: new Date(event.scheduled_at),
      end: new Date(event.scheduled_at),
    })) || [];

  return (
    <div>
      <BigCalendar
        date={date ? new Date(date) : new Date()}
        localizer={localizer}
        events={parseEvents}
        startAccessor="start"
        endAccessor="end"
        style={{ height: '100ch' }}
      />
    </div>
  );
};

export default Calendar;
